import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';
import { toast } from 'react-toastify';
import FeatureHeader from './FeatureHeader';

export default function ProfileSettings({ onBack }) {
  const { profile, user, fetchProfile } = useAuth();
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    dob: '',
    gender: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (profile) {
      setFormData({
        fullName: profile.fullName || '',
        phone: profile.phone || '',
        dob: profile.dob ? new Date(profile.dob).toISOString().split('T')[0] : '',
        gender: profile.gender || '',
      });
    }
  }, [profile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.post('/api/profile', formData);
      await fetchProfile();
      toast.success('Profile updated successfully');
      onBack();
    } catch (err) {
      console.error(err);
      toast.error('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      padding: '24px 16px',
      background: 'var(--bg)',
      fontFamily: 'sans-serif',
      color: 'var(--on-bg)',
    }}>
      <FeatureHeader title="Profile Settings" onBack={onBack} />
     
      {/* Avatar */}
      <div style={{
        width: 96,
        height: 96,
        borderRadius: '50%',
        background: profile?.avatar ? `url(${profile.avatar})` : 'linear-gradient(135deg, #7F5AF0, #9F7AEA)',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: '600',
        fontSize: '1rem',
        margin: '0 auto 24px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}>
        {!profile?.avatar && (profile?.fullName ? profile.fullName.slice(0, 2).toUpperCase() : 'U')}
      </div>

      {/* Form Fields */}
      <label style={labelStyle}>Full Name</label>
      <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} style={inputStyle} />

      <label style={labelStyle}>Email Address</label>
      <input type="email" value={user?.email || ''} readOnly style={inputStyle} />

      <label style={labelStyle}>Phone Number</label>
      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} />

      <label style={labelStyle}>Date of Birth</label>
      <input type="date" name="dob" value={formData.dob} onChange={handleChange} style={inputStyle} />

      <label style={labelStyle}>Gender</label>
      <select name="gender" value={formData.gender} onChange={handleChange} style={inputStyle}>
        <option value="">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
      </select>

      <button onClick={handleSave} disabled={loading} style={buttonStyle}>
        {loading ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  );
}

const labelStyle = {
  fontSize: '0.85rem',
  marginTop: 16,
  marginBottom: 6,
  display: 'block',
};

const inputStyle = {
  width: '100%',
  padding: 10,
  borderRadius: 8,
  border: '1px solid #ccc',
  background: 'var(--surface)',
  color: 'var(--on-bg)',
  fontSize: '0.9rem',
};

const buttonStyle = {
  marginTop: 24,
  padding: '10px 16px',
  background: 'var(--primary)',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  fontSize: '0.9rem',
  fontWeight: '500',
};